module.exports = __webpack_public_path__ + "img/3.788deb7.svg";